module.exports = __webpack_public_path__ + "img/integral_calculus.32343cdd.svg";